import { generateApiPath } from "@routes/generatePath";

const pathBase = `/reports/experiments/`;

export const experiments = {
  get: () => generateApiPath(pathBase),
};
